export const TAG_NAME = 'oryx-drawer';
